
import LocaleReceiver from 'ant-design-vue/es/locale-provider/LocaleReceiver';
import {CheckOutlined, SoundOutlined} from '@ant-design/icons-vue';
import EleColorPicker from '../../ele-color-picker';
// 默认主题色
const DEFAULT_THEMES = [
  {
    name: 'default',
    value: null,
    color: '#1890ff'
  },
  {
    name: 'dust',
    value: '#5f80c7'
  },
  {
    name: 'sunset',
    value: '#faad14'
  },
  {
    name: 'volcano',
    value: '#f5686f'
  },
  {
    name: 'purple',
    value: '#9266f9'
  },
  {
    name: 'green',
    value: '#33cc99'
  },
  {
    name: 'geekblue',
    value: '#32a2d4'
  }
];

export default {
  name: 'EleProSetting',
  components: {
    LocaleReceiver,
    CheckOutlined,
    SoundOutlined,
    EleColorPicker
  },
  emits: [
    'change-style',
    'change-color',
    'change-dark-mode',
    'change-weak-mode',
    'update:visible'
  ],
  props: {
    // 是否显示, 支持 v-model 绑定
    visible: Boolean,
    // 顶栏风格
    headStyle: String,
    // 侧边栏风格
    sideStyle: String,
    // 布局风格
    layoutStyle: String,
    // 侧栏边菜单风格
    sideMenuStyle: String,
    // 内容区域宽度是否铺满
    bodyFull: Boolean,
    // 是否固定顶栏
    fixedHeader: Boolean,
    // 是否固定侧栏
    fixedSidebar: Boolean,
    // 是否固定主体
    fixedBody: Boolean,
    // logo是否自适应宽度
    logoAutoSize: Boolean,
    // 侧栏是否多彩图标
    colorfulIcon: Boolean,
    // 侧边栏是否只保持一个子菜单展开
    sideUniqueOpen: Boolean,
    // 是否开启页脚
    showFooter: Boolean,
    // 是否色弱模式
    weakMode: Boolean,
    // 是否开启多标签
    showTabs: Boolean,
    // 标签页风格
    tabStyle: String,
    // 是否暗黑模式
    darkMode: Boolean,
    // 当前主题色
    color: String,
    // 主题列表
    themes: Array,
    // 提示文字
    tips: String,
    // 是否显示颜色选择器
    colorPicker: Boolean,
    // 颜色选择器预设颜色
    predefineColors: Array
  },
  data() {
    let chooseColor = this.color;
    if (this.color && typeof this.themes !== 'undefined' && this.themes !== null) {
      (this.themes.length ? this.themes : DEFAULT_THEMES).forEach((t) => {
        if (this.color === t.value) {
          chooseColor = null;
        }
      });
    }
    return {
      // 默认的主题色
      defaultThemes: DEFAULT_THEMES,
      // 颜色选择器选中颜色
      chooseColor: chooseColor
    };
  },
  methods: {
    /* 修改visible */
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    /* 切换主题色 */
    changeColor(value) {
      if (value !== this.color) {
        this.$emit('change-color', value);
      }
    },
    /* 修改主题风格 */
    changeStyle(key, value) {
      this.$emit('change-style', {key: key, value: value});
    },
    setHeadStyle(value) {
      this.changeStyle('headStyle', value);
    },
    setSideStyle(value) {
      this.changeStyle('sideStyle', value);
    },
    setLayoutStyle(value) {
      this.changeStyle('layoutStyle', value);
    },
    setSideMenuStyle(value) {
      this.changeStyle('sideMenuStyle', value ? 'mix' : 'default');
    },
    setBodyFull(value) {
      this.changeStyle('bodyFull', value);
    },
    setFixedHeader(value) {
      this.changeStyle('fixedHeader', value);
    },
    setFixedSidebar(value) {
      this.changeStyle('fixedSidebar', value);
    },
    setFixedBody(value) {
      this.changeStyle('fixedBody', value);
      if (value) {
        document.body.style.width = null;
      }
    },
    setLogoAutoSize(value) {
      this.changeStyle('logoAutoSize', value);
    },
    setColorfulIcon(value) {
      this.changeStyle('colorfulIcon', value);
    },
    setSideUniqueOpen(value) {
      this.changeStyle('sideUniqueOpen', value);
    },
    setWeakMode(value) {
      this.$emit('change-weak-mode', value);
    },
    setDarkMode(value) {
      this.$emit('change-dark-mode', value);
    },
    setShowFooter(value) {
      this.changeStyle('showFooter', value);
      if (!value) {
        document.body.style.width = null;
      }
    },
    setShowTabs(value) {
      this.changeStyle('showTabs', value);
    },
    setTabStyle(value) {
      this.changeStyle('tabStyle', value);
    }
  }
}
